import React, { useState } from "react";
import CommonMobileNumber from "@components/mobilenumber/MobileNumber";
import styles from "./HomePage.module.css";
import LoginIllustration from "@assets/homepageimages/login-illustration.svg";
import LoginTopImg from "@assets/homepageimages/login-top-image.svg";
import LoginBottomImg from "@assets/homepageimages/login-bottom-image.svg";
import { setComponentToShow } from "@store/ModalToShow";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import SendOtp from "@modals/sendotp/SendOtp";
import VerifyOtp from "@modals/verifyotp/VerifyOtp";
import EditPhoneNumber from "@modals/editphonenumber/EditPhoneNumber";
import LoginWithPassword from "@modals/loginwithpassword/LoginWithPassword";
import { setIsForgotPassword } from "@store/login/LoginStore";

const HomePage = () => {
  const dispatch = useDispatch();

  const componentName = useSelector(
    (state: any) => state.modalToShow.componentName
  );

  const renderComponent = () => {
    switch (componentName) {
      case "SendOtp":
        return (
          <SendOtp
            isOpen={true}
            onClose={() => {
              dispatch(setIsForgotPassword(false));
              dispatch(setComponentToShow(null));
            }}
          />
        );
      case "VerifyOtp":
        return (
          <VerifyOtp
            isOpen={true}
            onClose={() => {
              dispatch(setIsForgotPassword(false));
              dispatch(setComponentToShow(null));
            }}
          />
        );
      case "EditPhoneNumber":
        return (
          <EditPhoneNumber
            isOpen={true}
            onClose={() => {
              dispatch(setIsForgotPassword(false));
              dispatch(setComponentToShow(null));
            }}
          />
        );
      case "LoginWithPassword":
        return (
          <LoginWithPassword
            isOpen={true}
            onClose={() => {
              dispatch(setIsForgotPassword(false));
              dispatch(setComponentToShow(null));
            }}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className={styles.loginContainer}>
      <img src={LoginTopImg} alt="Top background" className={styles.topImage} />
      <img
        src={LoginBottomImg}
        alt="Bottom background"
        className={styles.bottomImage}
      />
      <div className={styles.leftSection}>
        <h1 className={styles.title}>
          Welcome to
          <br />
          <span>
            SUBJECTIVE ASSESSMENT
            <br />
            ADMIN PORTAL
          </span>
        </h1>
        <div className={styles.loginForm}>
          <CommonMobileNumber />
        </div>
      </div>
      <div className={styles.rightSection}>
        <img
          src={LoginIllustration}
          alt="Login Illustration"
          className={styles.mainImage}
        />
      </div>
      {renderComponent()}
    </div>
  );
};

export default HomePage;
